import { z } from 'zod';
import { addressSchema, agreementsSchema, currencySchema, ibanIdSchema, limitIdSchema, moneySchema, offerIdSchema, offerSchema, periodSchema, personSchema, preLimitIdSchema, representativeIdSchema, requestIdSchema, providerType, } from '@repo/shared/types';
import { loanResponseBaseSchema } from './loan-shared.schema';
export var loanOfferRequestBodySchema = z.object({
    requestId: requestIdSchema,
    data: z.object({
        preLimitId: preLimitIdSchema,
        limitId: limitIdSchema.nullable(),
        source: z.string().nullable(),
        agreements: agreementsSchema.nullable(),
        loan: z.object({
            amount: moneySchema,
            currency: currencySchema,
            period: periodSchema.nullable(),
            pricing: moneySchema.nullable(),
            loanRepaymentPrice: moneySchema.nullable(),
            name: z.string(),
            provider: providerType,
            representativeId: representativeIdSchema,
            ibanId: ibanIdSchema,
        }),
        offerId: offerIdSchema.nullable(),
        merchantData: z.object({
            address: addressSchema,
            companyRegisterDate: z.string().nullish(),
        }),
        person: personSchema.nullable(),
    }),
});
export var loanOfferSuccessResponse = loanResponseBaseSchema.extend({
    data: z.object({
        offers: z.array(offerSchema),
        limit: z.object({
            id: preLimitIdSchema,
            min: z.number(),
            max: z.number(),
            currency: currencySchema,
            provider: providerType,
            used: z.number().optional(),
            available: z.number(),
            minMaxDifference: z.boolean(),
        }),
    }),
});
